import React from 'react';
import StudentLeaveBoard from '../components/StudentLeaveBoard';

// แจ้งลานักเรียนของหัวหน้าวิชาการสามัญ (pos 3/4) — ใช้หน้าจอเดียวกับฝ่ายปกครอง
// แต่ยิงไปที่ /api/academic/leaves ซึ่งประทับ source = 'academic' ให้ป้ายในหน้า
// เช็คชื่อขึ้นว่า "หัวหน้าวิชาการแจ้งลา" และลบได้เฉพาะรายการที่ฝ่ายนี้แจ้งเอง
// (รายการของครูประจำชั้น/ฝ่ายปกครองยังอยู่ในตารางให้เห็น แต่ไม่มีปุ่มลบ)
export default function AcademicStudentLeave() {
  return (
    <StudentLeaveBoard
      roleLabel="หัวหน้าวิชาการสามัญ"
      title="แจ้งลานักเรียน (ป่วย/ลากิจ)"
      leavesPath="/api/academic/leaves"
      searchPath="/api/academic/leave-students"
      canDeleteLeave={(l) => l.source === 'academic'}
      intro={
        <>หัวหน้าวิชาการสามัญแจ้งลาให้นักเรียนได้ทุกคน โดยค้นหาจากเลขประจำตัวหรือชื่อ
          &nbsp;— รายการลาจะแสดงเป็นสถานะ "ลา" อัตโนมัติในหน้าเช็คชื่อรายคาบของวันที่อยู่ในช่วงลา
          (มีผลกับการเช็คชื่อ<strong>ครั้งถัดไป</strong>เท่านั้น) ลบได้เฉพาะรายการที่หัวหน้าวิชาการแจ้งเอง</>
      }
    />
  );
}
